"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var vf_model_1 = require("../vf-model");
var axios_1 = require("axios");
var logger_1 = require("./logger");
var vf_progress_1 = require("./vf-progress");
var VFAssetLoader = (function () {
    function VFAssetLoader() {
    }
    VFAssetLoader.reset = function () {
        this.CdnUrls = {};
    };
    VFAssetLoader.LoadModelFromGLB = function (scene, modelURL) {
        return new Promise(function (resolve, reject) {
            scene.getEngine().enableOfflineSupport = false;
            babylonjs_1.SceneLoader.ShowLoadingScreen = false;
            vf_progress_1.default.onDownload(false, 0.0);
            var filesize = 0;
            axios_1.default.head(modelURL, { headers: { Range: "bytes=0-0" } })
                .then(function (response) {
                filesize = response.headers["content-length"];
            })
                .finally(function () {
                vf_progress_1.default.onDownload(false, 0.0, filesize);
                babylonjs_1.SceneLoader.ImportMesh("", modelURL, "", scene, function (meshes) {
                    resolve(new vf_model_1.default(meshes, null, filesize));
                    vf_progress_1.default.onDownload(true, filesize, filesize);
                }, function (evt) {
                    vf_progress_1.default.onDownload(false, evt.loaded, filesize);
                }, function (scene, message, exception) {
                    logger_1.default.error("LoadModelFromGLB.ImportMesh failed", message);
                    reject("Failed to load model");
                    vf_progress_1.default.onDownload(true, 1.0, filesize);
                }, ".glb");
            });
        });
    };
    VFAssetLoader.LoadModelFromAuraWeb = function (scene, modelURL, modelMeta) {
        var _this = this;
        this.totalTextureCount = 0;
        this.textureLoadedCount = 0;
        var observer = scene.onNewTextureAddedObservable.add(function (arg) {
            _this.totalTextureCount += 1;
            vf_progress_1.default.onTextureLoad(_this.textureLoadedCount, _this.totalTextureCount);
            _this.onTextureLoaded(arg);
        });
        return new Promise(function (resolve, reject) {
            scene.getEngine().enableOfflineSupport = false;
            scene.getEngine().disableManifestCheck = true;
            babylonjs_1.SceneLoader.ShowLoadingScreen = false;
            vf_progress_1.default.onReset();
            axios_1.default.get(modelURL)
                .then(function (response) {
                var websceneObject = response.data;
                var modelVersion = undefined;
                if (modelMeta && modelMeta.version) {
                    modelVersion = modelMeta.version;
                }
                VFAssetLoader.requestAssetUrlFor(scene, "scene.glb", "auraweb", modelVersion).then(function (glbUrl) {
                    websceneObject["glb"] = glbUrl;
                    var filesize = 0;
                    axios_1.default.head(glbUrl)
                        .then(function (response) {
                        filesize = response.headers["content-length"];
                        logger_1.default.debug("HEAD GLB content-length: " + filesize);
                    })
                        .finally(function () {
                        vf_progress_1.default.onDownload(false, 0.0, filesize);
                        babylonjs_1.SceneLoader.ImportMesh("", glbUrl, "", scene, function (meshes) {
                            resolve(new vf_model_1.default(meshes, websceneObject, filesize, modelVersion));
                            vf_progress_1.default.onComplete();
                            scene.onNewTextureAddedObservable.remove(observer);
                        }, function (evt) {
                            vf_progress_1.default.onDownload(false, evt.loaded, filesize);
                        }, function (scene, message, exception) {
                            logger_1.default.error("LoadModelFromAuraWeb.ImportMesh failed", message);
                            reject("Failed to load model");
                            vf_progress_1.default.onComplete();
                        }, ".glb");
                    });
                });
            })
                .catch(function (error) {
                logger_1.default.error("problem with request: " + error);
                reject("Failed to load model: " + error);
                vf_progress_1.default.onComplete();
            });
        });
    };
    VFAssetLoader.onTextureLoaded = function (texture) {
        var _this = this;
        if (texture.isReady()) {
            this.textureLoadedCount += 1;
            vf_progress_1.default.onTextureLoad(this.textureLoadedCount, this.totalTextureCount);
            return;
        }
        setTimeout(function () {
            _this.onTextureLoaded(texture);
        }, 500);
    };
    VFAssetLoader.requestAssetUrlFor = function (scene, filenameWithExtension, path, version) {
        return __awaiter(this, void 0, void 0, function () {
            var url, parts, filename, fileExtension, requestUrl;
            return __generator(this, function (_a) {
                url = VFAssetLoader.CdnUrls[filenameWithExtension];
                if (url != null) {
                    logger_1.default.warn("using cached url for file", filenameWithExtension, url);
                    return [2, url];
                }
                parts = filenameWithExtension.split(".");
                filename = parts[0];
                fileExtension = parts[1];
                if (scene.playerConfig.customApiUrl) {
                    if (path != null) {
                        if (path.includes("auraweb/tex_")) {
                            return [2, scene.apiUrl + path.replace("auraweb", "") + "/" + filenameWithExtension];
                        }
                    }
                    if (scene.apiUrl.endsWith("/")) {
                        return [2, scene.apiUrl + filenameWithExtension];
                    }
                    else {
                        return [2, scene.apiUrl + "/" + filenameWithExtension];
                    }
                }
                if (version === undefined) {
                    if (scene.model !== undefined) {
                        version = scene.model.version;
                    }
                    else {
                        version = "1";
                    }
                }
                requestUrl = this.buildAssetRequestFor(scene.apiUrl, filename, fileExtension, scene.edgeEnabled, path, version);
                logger_1.default.debug("GET request: " + requestUrl);
                return [2, axios_1.default.get(requestUrl, {
                        headers: {
                            Authorization: "Basic " + scene.auth,
                        },
                    })
                        .then(function (res) {
                        var url = res.data["redirect_to"];
                        VFAssetLoader.CdnUrls[filenameWithExtension] = url;
                        return url;
                    })
                        .catch(function (error) {
                        logger_1.default.error("Asset '" + filenameWithExtension + "' could not be loaded", error);
                        scene.onSceneFailedLoading("Asset '" + filenameWithExtension + "' could not be loaded.");
                        return null;
                    })];
            });
        });
    };
    VFAssetLoader.buildAssetRequestFor = function (apiUrl, filename, extension, edgeEnabled, path, version) {
        var url = apiUrl + filename + "?ext=" + extension + "&client=aura-player-js&inspect=1&cloudfront=" + edgeEnabled;
        if (path) {
            url += "&path=" + path;
        }
        if (version) {
            url += "&version=" + version;
        }
        return url;
    };
    VFAssetLoader.CdnUrls = {};
    VFAssetLoader.totalTextureCount = 0;
    VFAssetLoader.textureLoadedCount = 0;
    return VFAssetLoader;
}());
exports.default = VFAssetLoader;
